import React from 'react';
import { TweenLite } from 'gsap';
import GQFlag from '../../../../GQFlag';
import GQPopupStorage from '../../../../GQPopup/GQPopupStorage';

interface IGQCGListItemProps {
    disabled: boolean;
    id: number;
    name: string;
    onClick?: (id?: number) => void;
}

export default class GQCGListItem extends React.Component<IGQCGListItemProps> {
    private itemID: string = null;
    private wrapID: string = null;

    public componentDidMount() {
        this.wrapID = 'cgWrap' + this.props.id;
        this.itemID = 'cgItem' + this.props.id;
    }
    public render() {
        return (
            <div
                id={this.wrapID}
                className="gq-cg-selected-item-wrapper"
                onMouseEnter={this.onHover}
                onMouseLeave={this.onHoverOut}
                onClick={this.onClick}>
                <div id={this.itemID} className="gq-cg-selected-item">
                    <GQFlag
                        countryId={this.props.id}
                        className="flag-icon-squared"
                        hideTooltip={true}
                    />
                    <i className="gqi-close gq-cg-selected-item-hover" />
                </div>
            </div>
        );
    }
    private onHover = (e: React.MouseEvent<HTMLDivElement>) => {
        GQPopupStorage.addData('gq-flag', {
            element: e.currentTarget,
            orientation: 'bottom center',
            tooltipData: (
                <span className="gq-flag-popup">{this.props.name}</span>
            ),
        });
        if (this.props.disabled) {
            return;
        }
        TweenLite.fromTo(
            '#' + this.itemID,
            0.5,
            { rotationY: 0 },
            { rotationY: -180, ease: 'Back.easeOut' }
        );
    };
    private onHoverOut = (e: React.MouseEvent<HTMLDivElement>) => {
        GQPopupStorage.addData('gq-flag', null);
        if (this.props.disabled) {
            return;
        }
        TweenLite.fromTo(
            '#' + this.itemID,
            0.5,
            { rotationY: -180 },
            { rotationY: 0, ease: 'Back.easeOut' }
        );
    };
    private onClick = () => {
        if (this.props.disabled) {
            return;
        }
        if (this.props.onClick) {
            this.props.onClick(this.props.id);
        }
    };
}
